import CheckInput from 'assets/components/inputs/check/CheckInput';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { inputStyles } from 'assets/components/inputs/Input';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales } from 'assets/locales/Locale';
import { defaultDateFormat, defaultDateTimeFormat } from 'assets/utils/data/Date';
import InputType from 'models/enums/InputType';

type Props<TFillabledPdfField extends Model.IFillablePdfField> = {
  fillablePdfField: Utils.FormData<TFillabledPdfField>;
  onValueChange(data: Partial<TFillabledPdfField>): void;
};
export function DefaultValueInput<TFillabledPdfField extends Model.IFillablePdfField>({
  onValueChange,
  fillablePdfField,
}: Props<TFillabledPdfField>) {
  const { lang } = getLocales();
  function getInputProps() {
    const defaultProps = {
      name: 'defaultValue',
      value: null,
      label: lang.default,
      onChange: (value: { [x: string]: string | number | boolean }) => {
        onValueChange(value as Partial<TFillabledPdfField>);
      },
    };
    if (
      typeof fillablePdfField?.defaultValue === 'string' ||
      typeof fillablePdfField?.defaultValue === 'number' ||
      typeof fillablePdfField?.defaultValue === 'boolean'
    ) {
      defaultProps.value = fillablePdfField?.defaultValue;
    }
    return defaultProps;
  }
  return (
    <>
      {fillablePdfField.type === InputType.text && <TextInput {...getInputProps()} />}
      {fillablePdfField.type === InputType.longText && <MultilineTextInput {...getInputProps()} />}
      {fillablePdfField.type === InputType.boolean && (
        <CheckInput {...getInputProps()} class={inputStyles.check.switch} />
      )}
      {(fillablePdfField.type === InputType.date || fillablePdfField.type === InputType.dateTime) && (
        <DateInput
          {...getInputProps()}
          dateTimeFormat={fillablePdfField.type === InputType.dateTime ? defaultDateTimeFormat : defaultDateFormat}
        />
      )}
      {(fillablePdfField.type === InputType.number || fillablePdfField.type === InputType.decimal) && (
        <NumberInput {...getInputProps()} step={fillablePdfField.type === InputType.number ? 1 : 0.01} />
      )}
      {fillablePdfField.type === InputType.year && <NumberInput {...getInputProps()} step={1} min={1000} max={9999} />}
      {fillablePdfField.type === InputType.month && <NumberInput {...getInputProps()} step={1} min={1} max={12} />}
      {fillablePdfField.type === InputType.day && <NumberInput {...getInputProps()} step={1} min={1} max={31} />}
    </>
  );
}
